/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnTaxEditor extends Common.GridEditorBase<JobWorkReturnTaxRow> {
        protected getColumnsKey() { return "Common.CommonTax"; }
        protected getLocalTextPrefix() { return JobWorkReturnTaxRow.localTextPrefix; } 

    

        constructor(container: JQuery) {
            super(container);
        }
        public getData(TaxDetails) {
            var tmp =[];
            for (let orderDetail of TaxDetails) { 
                orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                var x = orderDetail;
                tmp.push(orderDetail);
            }
            return tmp;

        }



        public DeleteTax() {
            var data = [];
            this.view.setItems(data, false);
            this.view.refresh();
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }


        protected getButtons() {
            let buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

    }
}